import { readable } from 'svelte/store';

export const connectionConfig = readable({
    endpoint: 'https://api.devnet.solana.com',
    commitment: 'processed',
});

export const programID = readable('437pvxJrLfiZefAR3skQGrPZe7nXzPrJ4SMMnmhfkSav');
